
import React, { Component } from 'react';
import ReactDOM from 'react-dom';


const WithdrawCarrier = (props) => {

    const handleRouteClick = (e) => {
        e.stopPropagation();
        props.context.componentParent.onClickWithdrawCarrierAction(props.data);
    };
    return (
        <div className="map-icon-component">
			     <button onClick={handleRouteClick} className="btn btn-danger btn-xs" title="Withdraw Carrier">Withdraw Carrier </button>
        </div>
    );
};

export default WithdrawCarrier;
